import React, {createContext, useContext, useEffect, useReducer, useState} from "react";
import {useEventContext} from "./EventContext";
import tokenStorage from "../tokenStorage";
import {jwtDecode} from "jwt-decode";
import {ClientLogin} from "../components/Authorization/ClientLogin";
import {Modal} from "react-bootstrap";
import {setClient} from "../actions/client";

const ACTION_LOGIN = 'LOGIN';
const ACTION_LOGOUT = 'LOGOUT';

const actionLogin = (client) => ({type: 'LOGIN', client})
const actionLogout = () => ({type: 'LOGIN'})

const clientReducer = (state, action) => {
    switch (action.type) {
        case ACTION_LOGIN: return action.client;
        case ACTION_LOGOUT: return null;
        default: return state;
    }
}

export const ClientContext = createContext(null);

export const ClientProvider = ({children}) => {
    const {event} = useEventContext();
    const [client, dispatch] = useReducer(clientReducer, null);
    const [isFormVisible, setFormVisible] = useState(false);

    const requiredFields = event.registrationFields
        .filter(({required, field: {name}}) => {
            return !client || (required && !client[name] && !client?.info[name]);
        });

    useEffect(() => {
        if (!event) {
            return;
        }

        tokenStorage.setEventKey(event.eventKey);

        const listener = () => {
            try {
                const payload = jwtDecode(tokenStorage.get());
                if (payload?.clientRegistrationId ?? payload?.id) {
                    setClient(payload);
                    return dispatch(actionLogin(payload));
                }
            } catch (e) {}

            setClient(null);
            return dispatch(actionLogout());
        }

        tokenStorage.addEventListener(listener);
        listener();

        return () => {
            tokenStorage.removeEventListener(listener);
        }
    }, [event]);

    useEffect(() => {
        if (client && requiredFields.length === 0) {
            setFormVisible(false);
        }
    }, [client]);

    const context = {
        client,
        logout() {
            console.log('logout')
        },
        login() {
            setFormVisible(true);
        }
    }

    return (
        <ClientContext.Provider value={context}>
            <Modal show={isFormVisible && (!client || requiredFields.length > 0)} onHide={() => setFormVisible(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Авторизация</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="login-form">
                        <ClientLogin
                            onLogin={(client) => dispatch(actionLogin(client))}
                            onLogout={() => dispatch(actionLogout())}
                        />
                    </div>
                </Modal.Body>
            </Modal>
            {children}
        </ClientContext.Provider>
    );
}

export const useClientContext = () => useContext(ClientContext);
